import React, { useEffect, useState } from 'react'
import { Typography } from 'antd'

import { getRandomWorkingMessageKey } from '@vacationtracker/shared/functions/working-messages'
import IntlMessages from '../../util/IntlMessages'
import { VeeMark } from './vee-mark'

const ROTATE_INTERVAL_MS = 4000
const SLOW_HINT_AFTER_MS = 3500

export const VeeWorking: React.FC = () => {
  const [messageKey, setMessageKey] = useState(getRandomWorkingMessageKey)
  const [showSlowHint, setShowSlowHint] = useState(false)

  useEffect(() => {
    const rotation = setInterval(() => setMessageKey(getRandomWorkingMessageKey()), ROTATE_INTERVAL_MS)
    const slowHint = setTimeout(() => setShowSlowHint(true), SLOW_HINT_AFTER_MS)
    return () => {
      clearInterval(rotation)
      clearTimeout(slowHint)
    }
  }, [])

  return (
    <div className="vee-working" role="status">
      <VeeMark size={48} working />
      <div className="vee-working-text">
        {/* The rotating quip changes every few seconds - hidden from screen readers so it doesn't spam announcements. */}
        <Typography.Text aria-hidden>
          <IntlMessages id={messageKey} />
        </Typography.Text>
        {showSlowHint && (
          <Typography.Text type="secondary" className="vee-working-slow-hint">
            <IntlMessages id="veeAssistant.slowHint" />
          </Typography.Text>
        )}
      </div>
    </div>
  )
}
